const regex = {
  "fName": /^[^<>]+$/,
  "fName2": /^[^<>]+$/,
  "lName": /^[^<>]+$/,
  "lName2": /^[^<>]+$/,
  "dob": /^\d{2}\/\d{2}\/\d{4}$/,
  "rCode": /^[A-z0-9\s]+$/,
  "discloseHealthInitial": /^[a-zA-Z]\.?[a-zA-Z](\.?[a-zA-Z])*\.?$/,
  "customConsentInitial": /^[a-zA-Z]\.?[a-zA-Z](\.?[a-zA-Z])*\.?$/,
  "email": /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  "password": /^(?=.{12,25}$)/,
  "confirmPassword": /^(?=.{12,25}$)/,
  "address1": /^[^<>]+$/,
  "address2": /^[^<>]*$/,
  "state": /^[^<>]+$/,
  "city": /^[^<>]+$/,
  "zip": /^(\s*)(\d{5}(-\d{4})?)(\s*)$/,
  "postal": /^(\s*)([A-Za-z]{1}\d{1}[A-Za-z]{1}[ ]{0,1}\d{1}[A-Za-z]{1}\d{1})(\s*)$/,
  "country": /^[^<>]+$/,
  "timezone": /^[^<>]+$/,
  "phone": /^\(\d{3}\)\s\d{3}-\d{4}$/,
  "mobilePhone": /^\(\d{3}\)\s\d{3}-\d{4}$/,
  "waist": /^[1-9][0-9]{0,2}$/,
  "weight": /^[1-9][0-9]{0,2}$/,
  "height": /^[1-9][0-9]{0,2}$/,
  "MEMBER ID": /^[^<>]+$/,
  "SID": /^[^<>]+$/,
  "SID-JPMC": /^(?!\s*$).+/,
  "UNIQUE ID": /^[^<>]+$/,
  "GENERIC": /^[^<>]+$/,
  "SSN": /^(\s?)+\d{4}(\s?)+$/,
}
export default regex